import adminAuthService from "../services/admin-auth.service";

const admin = JSON.parse(localStorage.getItem("auth_admin"));
const initialState = admin
    ? { status: { loggedIn: true }, admin }
    : { status: { loggedIn: false }, admin: null };

export const auth_admin = {
    namespaced: true,
    state: initialState,
    getters: {
        isLogged(state) {
            return state.status.loggedIn;
        },
        isSportips(state) {
            return state.admin.privilege == 'sportips';
        },
        hasSuperAdminRights(state) {

            return state.admin.privilege == 'sportips' && (state.admin.username == 'florian' || state.admin.username == 'yann');

        },
        hasModuleAccess(state, _, rootState) {
            if (state.admin.privilege == "sportips") return true;
            for (let i = 0; i < state.admin.list_modules.length; i++) {
                if (state.admin.list_modules[i] == rootState.module.id) return true;

            }
            return false;
        },
        hasAdminRights(state) {
            if (state.admin.privilege == "sportips") return true;
            if (state.admin.privilege == "admin") return true;
            return false;
        },
        hasVerificateurRights(state) {
            if (state.admin.privilege == 'pc_course' || state.admin.privilege == 'respo_medical' || state.admin.privilege == 'coordinateur') return true;
            return false;
        },
        is_sportips(state) {
            return state.admin.privilege == 'sportips';
        }
    },
    actions: {
        login({ commit }, admin) {

            return adminAuthService.login(admin).then(
                admin => {
                    commit("loginSuccess", admin.data);
                    return Promise.resolve(admin.data);
                },
                error => {
                    commit("loginFailure");
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            adminAuthService.logout();
            commit("logout");
        },


        register({ commit }, admin) {
            return adminAuthService.register(admin).then(
                response => {

                    commit("registerSuccess");
                    return Promise.resolve(response);
                },
                error => {
                    commit("registerFailure");
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        loginSuccess(state, admin) {
            state.admin = admin;
            state.status.loggedIn = true;

        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.admin = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.admin = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;

        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },

    }
};